import { render, staticRenderFns } from "./docs.vue?vue&type=template&id=28296041&scoped=true&"
import script from "./docs.vue?vue&type=script&lang=js&"
export * from "./docs.vue?vue&type=script&lang=js&"
import style0 from "./docs.vue?vue&type=style&index=0&id=28296041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28296041",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28296041')) {
      api.createRecord('28296041', component.options)
    } else {
      api.reload('28296041', component.options)
    }
    module.hot.accept("./docs.vue?vue&type=template&id=28296041&scoped=true&", function () {
      api.rerender('28296041', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/docs/docs.vue"
export default component.exports